import moment from 'moment'
import { getNow } from '../../logic/date-logic'

export const getThisWeek = (): number => {
    return getNow().startOf('week').unix()
}